import { jeepRallyApi } from "../api";

const routesBaseUrl = "/api/v1/routes";

export const getAllRoutes = (params = {}) => {
  const query = {};
  if (params.status === "active" || params.status === "inactive") {
    query.status = params.status;
  }

  return jeepRallyApi.get(routesBaseUrl, { params: query });
};

export const getRouteById = (routeId) => {
  return jeepRallyApi.get(`${routesBaseUrl}/${routeId}`);
};

export const createRoute = (payload) => {
  return jeepRallyApi.post(routesBaseUrl, payload);
};

export const updateRoute = (routeId, payload) => {
  return jeepRallyApi.put(`${routesBaseUrl}/${routeId}`, payload);
};

export const updateRouteTrackMap = (routeId, formData) => {
  return jeepRallyApi.patch(`${routesBaseUrl}/${routeId}/track-map`, formData);
};

export const deleteRoute = (routeId) => {
  return jeepRallyApi.delete(`${routesBaseUrl}/${routeId}`);
};
